import { Button, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { getPaymentgetwayRequest } from "../../api/api";
import CustomTable from "../../components/_common/Table";
import { useAppSelector, useAppDispatch } from "../../redux/store/storehooks";
import { errorNotify } from "../../services/toast.notification";
import { useNavigate } from 'react-router-dom';


const RequestPayment = () => {
    const [data,setData] = useState<any[]>([]);
    const columns: ColumnsType<any> = [
        // {title: 'عملیات',dataIndex: 'Action',key: 'Action',render:(_,record) => (
        //     <Button type="primary" style={{backgroundColor:"orange"}}     
        //     onClick={()=>
        //         uploadFile(record)}> آپلود فایل</Button>
        // )},
        {title: 'نام آزمایشگاه',dataIndex: 'str_LabPersianName',key: 'str_LabPersianName'},
        {title: 'استان',dataIndex: 'str_StateName',key: 'str_StateName'},
        {title: 'تاریخ درخواست',dataIndex: 'str_RequestDateTime',key: 'str_RequestDateTime'},
        {title: 'تاریخ انجام',dataIndex: 'str_ApproveDateTime',key: 'str_ApproveDateTime'},
        {title: 'وضعیت',dataIndex: 'str_Status',key: 'str_Status'},
        {title: 'تست درگاه',dataIndex: 'bit_IsTestPaymentgateway',key: 'bit_IsTestPaymentgateway'},
        {title: 'استفاده از ssl پارسی پل',dataIndex: 'bit_useParsipolSSL',key: 'bit_useParsipolSSL'},
        {title: 'انجام دهنده',dataIndex: 'str_ApproveuserId',key: 'str_ApproveuserId'},
        {title: 'توضیحات',dataIndex: 'str_Descritption',key: 'str_Descritption'},

    ];
    const navigate = useNavigate();
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading,setIsLoading] = useState(true);

    useEffect(()=>{
        getData()

    },[])
 const getData = () => {
        
    getPaymentgetwayRequest(myStore.auth.userId?+myStore.auth.userId:0)
      .then((result:any) => {
        result.data.data=result.data.data.map((item:any)=>{
            item.bit_useParsipolSSL=item.bit_useParsipolSSL?'شده':'نشده'
            item.bit_IsTestPaymentgateway=item.bit_IsTestPaymentgateway?'شده':'نشده'
            return item
        })
        setData(result.data.data);
        setIsLoading(false);
       
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage,undefined,5000)
       
      })
    }
    const uploadFile=(item:any)=>{
        // 
      
        navigate("/labuser/UploadFormat/" + item.prk_PaymentgetwayRequest_AutoID)
    }
    const addNewOnClick = () => {
        navigate("/labuser/newRequestPayment");
    }
    
    return (
        
        <>
            <Row>
                <CustomTable columns={columns} data={data} 
                isloading={isLoading} onAddClick={addNewOnClick} permission={true}/>
            </Row>
        </>
    );
};

export default RequestPayment